var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{on:{"click":_vm.openDialog}}),_c('formPasswordValidation',{attrs:{"dialog":_vm.visible}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }